
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Mehul ",
  title: "Hi all, I'm Mehul",
  subTitle: emoji("A Full Stack Engineer 🚀  and passionate about Web and Technology in general, with tons of interest in the field of Machine Learning and Artificial Intelligence."),
  resumeLink: "https://drive.google.com/file/d/1Qt6mUMnAOe-MJbzgQpRJ9C-tBLkk9DbY/view?usp=sharing"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/mehul-anshumali",
  linkedin: "https://www.linkedin.com/in/mehulanshumali/",
  gmail: "mehulanshumali.ma@gmail.com",
  // gitlab: "https://gitlab.com/mehul-anshumali",
  // instagram: "https://www.facebook.com/saad.pasta7"
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const aboutSection = {
  title: emoji("About Me 🙈"),
  subTitle: emoji(" 😊 What I do, what I like, what consumes most of my time etc. ✨ ✨"),
  subTitle1: emoji("📍 I'm a 20-year-old student at Jain University currently pursuing BTech. in CSE. "),
  subTitle2: emoji("📍 As I've grown as a developer. I've worked alongside with various developers and worked on my projects to raised my standards for whats expected of any web application."),
  subTitle3: emoji("📍 Through these experiences, I've had the opportunity to create memorable products that are not only enjoyable to use but are written in code that's maintainable and easy to understand."),
  subTitle4: emoji("📍 Skilled at writing well-designed, testable and efficient code using current best practices in Web development by using some cool libraries and frameworks."), 
  subTitle5: emoji("📍 Most of my time I spent by doing projects and learning new things and languages related to Technology."),
  subTitle6: emoji("📍 I occasionally play video games 🎮, initially just to try it but then ended up playing it 600+ hrs, apart from that I recently realized I like travelling as well. 😎"),
  subTitle7: emoji("📍 I'm open to new opportunities and always looking for new projects where I can contribute. Feel free to take a look at my complete resume.👇"), 
  
  
}

const skillsSection = {
  title: emoji("Skills 💪"),
  subTitle: [
    emoji("⚡ I love to learn new things and experiment with new technologies. Below are the few skills that I use on regular basis to create new projects.")
  ],

    skillCards: [
      {
        title: "Programming Languages",
        // subtitle: ".....",
        image: require("./assets/images/intro.gif"),
        footerLink: [
          { name: emoji("⚆ C/C++") },
          { name: emoji("⚆ Python3") },
          { name: emoji("⚆ Core Java") },
          { name: emoji("⚆ Unix/Shell") }
        ]
      },

      {
        title: "Full Stack Development",
        // subtitle: ".....",
        image: require("./assets/images/developer.gif"),
        footerLink: [
          { name: emoji("⚆ HTML5") },
          { name: emoji("⚆ CSS3/SCSS") },
          { name: emoji("⚆ JavaScript") },
          { name: emoji("⚆ ReactJS") },
          { name: emoji("⚆ Django") },
          { name: emoji("⚆ BootStrap") },
          { name: emoji("⚆ Flask") },
          { name: emoji("⚆ Materialize CSS") },
        ]
      },
      
      {
        title: "Data Science & Machine Learning",
        // subtitle: ".....",
        image: require("./assets/images/machine.gif"),
        footerLink: [
          { name: emoji("⚆ Supervised Learning Algorithms") },
          { name: emoji("⚆ Unsupervised Learning Algorithms") },
          { name: emoji("⚆ Basics of Reinforcement Learning & Transfer Learning") },
          { name: emoji("⚆ Neural | Deep Learning") },
          
        ]
      },
     
      {
        title: "Software Libraries & Tools",
        // subtitle: ".....",
        image: require("./assets/images/software.gif"),
        footerLink: [
          { name: emoji("⚆ Pandas") },
          { name: emoji("⚆ Numpy") },
          { name: emoji("⚆ Matplotlib") },
          { name: emoji("⚆ Seaborn") },
          { name: emoji("⚆ Scikit-Learn") },
          { name: emoji("⚆ Keras") },
          { name: emoji("⚆ Docker") },
          { name: emoji("⚆ Git & GitHub") },
        ]
      },
  ] 
};


/* Project Section to View Your Github Pinned Projects*/

const project = {
  githubConvertedToken: "a4642d2dd0922a81283d6528aa73664f32f62df9",
  githubUserName: "mehul-anshumali", // Change to your github username to view your profile in Contact Section.
  showGithubProfile :"true" // Set true or false to show Contact profile using Github, defaults to false 
};



/*const certifications = {
	certifications: [
		{
			title: "Machine Learning",
			subtitle: "- Andrew Ng",
			logo_path: "stanford_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
			alt_name: "Stanford University",
			color_code: "#8C151599"
		},
		{
			title: "Deep Learning",
			subtitle: "- Andrew Ng",
			logo_path: "deeplearning_ai_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
			alt_name: "deeplearning.ai",
			color_code: "#00000099"
		},
		{
			title: "ML on GCP",
			subtitle: "- GCP Training",
			logo_path: "google_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
			alt_name: "Google",
			color_code: "#0C9D5899"
		},
		{
			title: "Data Science",
			subtitle: "- Alex Aklson",
			logo_path: "ibm_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
			alt_name: "IBM",
			color_code: "#1F70C199"
		},
		{
			title: "Big Data",
			subtitle: "- Kim Akers",
			logo_path: "microsoft_logo.png",
			certificate_link:
				"https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
			alt_name: "Microsoft",
			color_code: "#D83B0199"
		},
		{
			title: "Advanced Data Science",
			subtitle: "- Romeo Kienzler",
			logo_path: "ibm_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
			alt_name: "IBM",
			color_code: "#1F70C199"
		},
		{
			title: "Advanced ML on GCP",
			subtitle: "- GCP Training",
			logo_path: "google_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
			alt_name: "Google",
			color_code: "#0C9D5899"
		},
		{
			title: "DL on Tensorflow",
			subtitle: "- Laurence Moroney",
			logo_path: "deeplearning_ai_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
			alt_name: "deeplearning.ai",
			color_code: "#00000099"
		},
		{
			title: "Fullstack Development",
			subtitle: "- Jogesh Muppala",
			logo_path: "coursera_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
			alt_name: "Coursera",
			color_code: "#2A73CC"
		},
		{
			title: "Kuberenetes on GCP",
			subtitle: "- Qwiklabs",
			logo_path: "gcp_logo.png",
			certificate_link:
				"https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
			alt_name: "GCP",
			color_code: "#4285F499"
		},
		{
			title: "Cryptography",
			subtitle: "- Saurabh Mukhopadhyay",
			logo_path: "nptel_logo.png",
			certificate_link:
				"https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
			alt_name: "NPTEL",
			color_code: "#FFBB0099"
		},
		{
			title: "Cloud Architecture",
			subtitle: "- Qwiklabs",
			logo_path: "gcp_logo.png",
			certificate_link:
				"https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
			alt_name: "GCP",
			color_code: "#4285F499"
		}
	]
};*/

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? I shall get back to you as early as possible. ",
  number: "",
  email_address: "mehulanshumali.ma@gmail.com"
};

export { greeting, 
  socialMediaLinks,
  aboutSection, 
  skillsSection, 
  project, 
  contactInfo

};
